import BoxContainer from "@standard/components/BoxContainer/BoxContainer";
import { useParams, useHistory } from "react-router-dom";
import { useState, memo } from "react";
import DataForm from "@standard/components/DataForm/DataForm";
import { FormService } from "@standard/services";
import { useEffect } from "react";

export default function PlaceForm({ url }) {
  const history = useHistory();
  const { id, action } = useParams();
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const defaultData = {
    id: id,
    customerName: "",
    name: "",
  };

  const [data, setData] = useState(defaultData);

  useEffect(() => {
    if (id !== undefined) {
      FormService.getRequest(url, id).then((result) => {
        setData(result);
        setIsLoading(false);
      });
    }
  }, []);

  const onSubmit = (newData) => {
    setIsLoading(true);

    const params = { ...newData, id: id };

    FormService.submitRequest(url, params)
      .then((result) => {
        setIsLoading(false);
        history.push(`/${url}`);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrors(err);
      });
  };

  const fields = [
    {
      label: "Customer Name",
      name: "customerName",
      type: "label",
      required: false,
    },
    {
      label: "Place",
      name: "name",
      type: "text",
      required: true,
    },
  ];

  return (
    <BoxContainer loading={isLoading} errors={errors}>
      <DataForm
        defaultValues={data}
        onSubmit={onSubmit}
        fields={fields}
        url={url}
        onErrors={(errors) => setErrors(errors)}
      ></DataForm>
    </BoxContainer>
  );
}
